<script lang="ts" setup>
import type { Game, GameClickEventEmit } from '@game/types'
import type { HeroContent } from '@nimbus/types'
import { computed, useI18n } from '#imports'

const props = defineProps<{
    game?: Game | null
    preset?: string
}>()

const { t } = useI18n()

const data = computed(() => {
    if (!props.game) return undefined

    return {
        design: 'game',
        compact: true,
        game: props.game,
        game_slug: props.game.slug,
        title: props.game.name,
        button_text: t('promotions.playNow'),
        enable_video: true,
        gradient_outer_color: props.game.game_hero_colour ?? undefined,
    } as HeroContent
})

const emit = defineEmits<GameClickEventEmit>()
</script>

<template>
    <NimbusHeroContainer
        :data="data"
        :preset="preset"
        @game-click="(game: Game) => emit('game-click', game)"
    />
</template>
